// extracted by mini-css-extract-plugin
export default {"events":"villagePlaces__events___[chunkhash-base64-5]","buildings":"villagePlaces__buildings___[chunkhash-base64-5]"};